import React from 'react';

import { Text } from '@zapier/design-system';

type Props = {
  children: React.ReactNode;
};

function Title({ children }: Props) {
  return (
    <Text margin="10px 0px 25px" tag="h2" type="ParagraphHeader4">
      {children}
    </Text>
  );
}

export default Title;
